// extracted by mini-css-extract-plugin
export default {"galleryItem":"c-p_fn","galleryItem_borderTopRadius":"c-p_fo","galleryItem__image":"c-p_fp"};